"use strict";function closePreviewImage$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.closePreviewImage$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.closePreviewImage";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.19"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.17"},_a)),exports.closePreviewImage$=closePreviewImage$,exports.default=closePreviewImage$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/closePreviewImage.js
// module id = 1003
// module chunks = 106